// assets
import { Key ,Dashboard, Assignment, Work, AssignmentInd, Paid, Folder } from '@mui/icons-material';

// constant
const icons = {
    Assignment,
    Dashboard,
    Work,
    AssignmentInd,
    Paid,
    Folder
};

// ==============================|| EXTRA PAGES MENU ITEMS ||============================== //

const pagesAdmin = {
    id: 'pages',
    title: '',
    caption: '',
    type: 'group',
    children: [
        {
            id: 'dashboard',
            title: 'Dashboard',
            type: 'item',
            url: '/backoffice/dashboard',
            icon: icons.Dashboard,
            breadcrumbs: false
        },
        {
            id: 'tramites',
            title: 'Trámites',
            type: 'item',
            url: '/backoffice/tramites',
            icon: icons.Assignment,
        },
        {
            id: 'cuentas',
            title: 'Cuentas',
            type: 'item',
            url: '/backoffice/cuentas',
            icon: icons.Work,
        },
        {
            id: 'usuarios',
            title: 'Usuarios',
            type: 'item',
            url: '/backoffice/usuarios',
            icon: icons.AssignmentInd,
        },
        {
            id: 'simulador',
            title: 'Simulador',
            type: 'item',
            url: '/backoffice/simulador',
            icon: icons.Paid,
        },
        {
            id: 'retiros',
            title: 'Historial de retiros',
            type: 'item',
            url: '/backoffice/retiros',
            icon: icons.Assignment,
        },
        {
            id: 'biblioteca',
            title: 'Biblioteca de recursos',
            type: 'item',
            url: '/backoffice/biblioteca',
            icon: icons.Assignment,
        },
        {
            id: 'inventario',
            title: 'Inventario de inversiones',
            type: 'item',
            url: '/backoffice/inventario',
            icon: icons.Assignment,
        },
        {
            id: 'comisiones',
            title: 'Comisiones',
            type: 'item',
            url: '/backoffice/comisiones',
            icon: icons.Paid,
        },
        {
            id: 'reportes',
            title: 'Reportes',
            type: 'item',
            url: '/backoffice/reportes',
            icon: icons.Folder,
        }
    ]
};

export default pagesAdmin;
